// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GwmTabXQ_SzH1T {
  padding-left: var(--ds-space-100, 8px);
  white-space: nowrap;
  display: inline-block;
}
`, ""]);
// Exports
export var connectButton = `GwmTabXQ_SzH1T`;
export default ___CSS_LOADER_EXPORT___;
